import { gql } from "@apollo/client";

const CREATEPLATFORM = gql`
  mutation CreatePlatform(
    $email: String
    $organizationName: String
    $organizationType: OrganizationType
    $organizationAbbreviation: String
    $contactEmail: String
    $phone: String
    $contactPhone: String
    $website: String
    $logo: Upload
    $signeeRole: String!
    $signeeFullName: String!
    $title: String!
    $platformType: String!
    $country: String!
    $sports: [Int!]
    $disciplines: [Int!]
    $thirdPartyLicenses: [Int!]
    $language: String
    $timeZone: String
    $currency: String
    $description: String
    $alreadyDomain: Boolean
    $platformLink: String
    $domain: String
    $companyName: String
    $registrationNumber: String
    $fullAddress: String
    $companyEmail: String
    $needLanding: Boolean
    $needIntegration: Boolean
    $onlinePayment: Boolean
    $licenseMemberships: Boolean
    $onlinePayments: Boolean
    $onlineBookingCourts: Boolean
    $liveStreaming: Boolean
    $liveScoring: Boolean
    $serviceProvider: String
    $primaryColor: String
    $secondaryColor: String
    $darkLogo: Upload
    $lightLogo: Upload
    $lightEmblem: Upload
    $darkEmblem: Upload
    $favicon: Upload
    $yourRequest: String
    $uploadFile: Upload
    $federationEmail: String
    $federationPublicId: String
    $password: String
    $role: String
    $federation: Int
    $mobileApp: Boolean
    $smm: Boolean
    $graphicsForSmm: Boolean
    $name: String
    $surname: String
    $about: String
    $instagram: String
    $template: Int
    $isEnablePrice: Boolean
    $status: String
    $landingLink: String
    $createCustomEntryFeeInput: [CreatePlatformFeeInput!]
    $createCustomLicenseFeeInput: [CreatePlatformFeeInput!]
    $isEnableMaintenance: Boolean
    $passcode: String
    $maintenanceDescription: String
    $maintenanceTitle: String
    $abbreviation: String
    $isMobileAppSupported: Boolean
    $subDomain: String
    $liveStreaming_sporfie_key: String
  ) {
    createPlatform(
      createPlatformInput: {
        title: $title
        abbreviation: $abbreviation
        platformType: $platformType
        status: $status
        country: $country
        sports: $sports
        disciplines: $disciplines
        thirdPartyLicenses: $thirdPartyLicenses
        signeeRole: $signeeRole
        signeeFullName: $signeeFullName
        language: $language
        timeZone: $timeZone
        currency: $currency
        description: $description
        alreadyDomain: $alreadyDomain
        platformLink: $platformLink
        primaryColor: $primaryColor
        secondaryColor: $secondaryColor
        uploadFile: $uploadFile
        yourRequest: $yourRequest
        lightEmblem: $lightEmblem
        darkEmblem: $darkEmblem
        lightLogo: $lightLogo
        darkLogo: $darkLogo
        favicon: $favicon
        serviceProvider: $serviceProvider
        liveScoring: $liveScoring
        liveStreaming: $liveStreaming
        onlineBookingCourts: $onlineBookingCourts
        onlinePayments: $onlinePayments
        licenseMemberships: $licenseMemberships
        onlinePayment: $onlinePayment
        needIntegration: $needIntegration
        needLanding: $needLanding
        companyEmail: $companyEmail
        fullAddress: $fullAddress
        registrationNumber: $registrationNumber
        companyName: $companyName
        domain: $domain
        mobileApp: $mobileApp
        smm: $smm
        graphicsForSmm: $graphicsForSmm
        template: $template
        isEnablePrice: $isEnablePrice
        landingLink: $landingLink
        isEnableMaintenance: $isEnableMaintenance
        passcode: $passcode
        maintenanceDescription: $maintenanceDescription
        maintenanceTitle: $maintenanceTitle
        isMobileAppSupported: $isMobileAppSupported
        subDomain: $subDomain
        liveStreaming_sporfie_key: $liveStreaming_sporfie_key
      }
      createFederationInput: {
        email: $email
        organizationName: $organizationName
        organizationAbbreviation: $organizationAbbreviation
        contactEmail: $contactEmail
        contactPhone: $contactPhone
        phone: $phone
        website: $website
        organizationType: $organizationType
        logo: $logo
        federationPublicId: $federationPublicId
        federationEmail: $federationEmail
        password: $password
        role: $role
        instagram: $instagram
        name: $name
        surname: $surname
        about: $about
      }
      createOrganizationPlatformInput: { federation: $federation }
      createCustomEntryFeeInput: $createCustomEntryFeeInput
      createCustomLicenseFeeInput: $createCustomLicenseFeeInput
    ) {
      id
      title
      currency
      description
    }
  }
`;

export default CREATEPLATFORM;
